export default __webpack_public_path__ + "static/media/ustpa_desktop.ce877b86.jpg";